import { menuItems } from '@/config/menu.config';
import { usePermissions } from '@/hooks/use-permissions';
import { useAccountFlags } from '@/hooks/use-account-flags';
import SecondarySidebarLayout from './secondary-sidebar-layout';
import { Outlet, useLocation } from 'react-router';

export default function AgentsLayout() {
	const { ability, isSuperAdmin } = usePermissions();
	const { flags } = useAccountFlags();
	const location = useLocation();
	if (location.pathname === '/agents/sales') {
		return <div className='h-svh overflow-hidden'><Outlet /></div>;
	}

	const agentsItem = menuItems.find((item) => item.activePrefix === '/agents');
	const isVisible = (subject?: string) => !subject || isSuperAdmin || ability.can('view', subject);
	const flagAllows = (flag?: string) => !flag || flags[flag] === true;
	const visibleSubItems =
		agentsItem?.subItems?.filter((s) => isVisible(s.subject) && flagAllows(s.flag)) ?? [];

	// "My Agents" rather than "Agents": the panel lists the agents this brand runs, which is
	// what the design says and what distinguishes it from the catalogue of agents Kim offers.
	return <SecondarySidebarLayout title='My Agents' items={visibleSubItems} />;
}
